import { ArrowUpRightIcon } from '@phosphor-icons/react';

import { Chip } from '@/components/common/chip';
import { formatIsoDate } from '@/lib/utils/format';

import { WARRANTY_STATUS_META } from '../constants';
import type { WarrantyClaim } from '../types';

import styles from './warranty-claim-card.module.scss';

export type WarrantyClaimCardProps = {
  claim: WarrantyClaim;
  onOpen: (claim: WarrantyClaim) => void;
};

/**
 * Listing card (Figma 2708-240334): device image, status chip, device name and the
 * "Last updated" date, with a top-right open affordance. A claim awaiting the grower's
 * reply shows a red "Response needed" flag; an otherwise-unseen status update shows an
 * unread dot (story 101872).
 */
export function WarrantyClaimCard({ claim, onOpen }: WarrantyClaimCardProps) {
  const meta = WARRANTY_STATUS_META[claim.status];

  return (
    <button type="button" className={styles.card} onClick={() => onOpen(claim)}>
      <span className={styles.open} aria-hidden>
        <ArrowUpRightIcon size={16} />
      </span>

      {claim.responseRequired ? (
        <span className={`${styles.flag} ${styles.flagAction}`}>Response needed</span>
      ) : claim.unread ? (
        <span className={styles.unreadDot} aria-label="Unread update" />
      ) : null}

      <span className={styles.imageWrap}>
        {claim.imageUrl ? (
          <img src={claim.imageUrl} alt="" className={styles.image} />
        ) : (
          <span className={styles.imageFallback} aria-hidden />
        )}
      </span>

      <span className={styles.chipRow}>
        <Chip intent={meta.intent}>{meta.label}</Chip>
      </span>
      <span className={styles.name}>{claim.deviceName}</span>
      <span className={styles.updated}>Last updated {formatIsoDate(claim.updatedAt)}</span>
    </button>
  );
}
